import { trigger, state, style, transition, animate } from '@angular/animations';

const fgbAnimations = [
    trigger('rotateAnimation', [
        state('1', style({
            transform: 'rotate({{ rotateEnd }}deg)'
        }), { params: { rotateEnd: 0 } }),
        state('0', style({
            transform: 'rotate({{ rotateStart }}deg)'
        }), { params: { rotateStart: 0 } }),
        transition('0 <=> 1', [
            animate('100ms ease-in')
        ])
    ]),
    trigger('collapseAnimation', [
        state('1', style({
            height: '*',
            overflow: 'hidden'
        })),
        state('0', style({
            height: 0,
            overflow: 'hidden'
        })),
        transition('0 <=> 1', animate('100ms ease-in'))
    ]),
    trigger('growAnimation', [
        transition(':enter, * => 0, * => -1', []),
        transition(':increment', [
            style({
                height: '{{ height }}px',
                overflow: 'hidden'
            }),
            animate('300ms ease'),
        ], { params: { height: 0 } })
    ]),
    trigger('shrinkAnimation', [
        transition(':enter, * => 0, * => -1', []),
        transition(':decrement', [
            style({
                height: '{{ end }}px',
                overflow: 'hidden'
            }),
            animate('300ms ease', style({
                height: '{{ start }}px'
            })),
        ], { params: { start: 0, end: 0 } })
    ]),
    trigger('slideUpAnimation', [
        transition(':enter', [
            style({ transform: 'translateY(100%)', opacity: 0 }),
            animate('150ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
        ]),
        transition(':leave', [
            animate('150ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
        ])
    ])
];

/**
 * Generated bundle index. Do not edit.
 */

export { fgbAnimations };
